/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AdminFleetFidClaim,
  AdminFleetFidClaims,
  DestroyedFleets,
  DestroyedFleetsParams,
  Fleet,
  FleetFidClaimUpdateInput,
  FleetFidClaimsParams,
  FleetInput,
  FleetOptions,
  FleetOptionsParams,
  Fleets,
  FleetsParams,
  RestoreDestroyedFleetParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Destroyed Fleets list
 */
export const destroyedFleets = (
    params?: MaybeRefOrGetter<DestroyedFleetsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<DestroyedFleets>(
      {url: `/destroyed-fleets`, method: 'GET',
        params, signal
    },
      );
    }




export const getDestroyedFleetsQueryKey = (params?: MaybeRefOrGetter<DestroyedFleetsParams>,) => {
    return [
    'destroyed-fleets', ...(params ? [params] : [])
    ] as const;
    }


export const getDestroyedFleetsQueryOptions = <TData = Awaited<ReturnType<typeof destroyedFleets>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<DestroyedFleetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof destroyedFleets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getDestroyedFleetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof destroyedFleets>>> = ({ signal }) => destroyedFleets(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof destroyedFleets>>, TError, TData>
}

export type DestroyedFleetsQueryResult = NonNullable<Awaited<ReturnType<typeof destroyedFleets>>>
export type DestroyedFleetsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Destroyed Fleets list
 */

export function useDestroyedFleets<TData = Awaited<ReturnType<typeof destroyedFleets>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<DestroyedFleetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof destroyedFleets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDestroyedFleetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Restore a destroyed fleet
 */
export const restoreDestroyedFleet = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<RestoreDestroyedFleetParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<Fleet>(
      {url: `/destroyed-fleets/${id}/restore`, method: 'POST',
        params, signal
    },
      );
    }




export const getRestoreDestroyedFleetMutationKey = () => ['restoreDestroyedFleet'] as const;

export const getRestoreDestroyedFleetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreDestroyedFleet>>, TError,RestoreDestroyedFleetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof restoreDestroyedFleet>>, TError,RestoreDestroyedFleetMutationVariables, TContext> => {

const mutationKey = getRestoreDestroyedFleetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreDestroyedFleet>>, RestoreDestroyedFleetMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  restoreDestroyedFleet(id,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreDestroyedFleetMutationResult = NonNullable<Awaited<ReturnType<typeof restoreDestroyedFleet>>>

    export type RestoreDestroyedFleetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type RestoreDestroyedFleetMutationVariables = {id: string;params?: RestoreDestroyedFleetParams}

    /**
 * @summary Restore a destroyed fleet
 */
export const useRestoreDestroyedFleet = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreDestroyedFleet>>, TError,RestoreDestroyedFleetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof restoreDestroyedFleet>>,
        TError,
        RestoreDestroyedFleetMutationVariables,
        TContext
      > => {
      return useMutation(getRestoreDestroyedFleetMutationOptions(options), queryClient);
    }
    /**
 * @summary Open FID claims
 */
export const fleetFidClaims = (
    params?: MaybeRefOrGetter<FleetFidClaimsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<AdminFleetFidClaims>(
      {url: `/fleet-fid-claims`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetFidClaimsQueryKey = (params?: MaybeRefOrGetter<FleetFidClaimsParams>,) => {
    return [
    'fleet-fid-claims', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetFidClaimsQueryOptions = <TData = Awaited<ReturnType<typeof fleetFidClaims>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<FleetFidClaimsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetFidClaims>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetFidClaimsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetFidClaims>>> = ({ signal }) => fleetFidClaims(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetFidClaims>>, TError, TData>
}

export type FleetFidClaimsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetFidClaims>>>
export type FleetFidClaimsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Open FID claims
 */

export function useFleetFidClaims<TData = Awaited<ReturnType<typeof fleetFidClaims>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<FleetFidClaimsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetFidClaims>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetFidClaimsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Shorten an FID claim's grace period
 */
export const updateFleetFidClaim = (
    id: MaybeRefOrGetter<string>,
    fleetFidClaimUpdateInput: MaybeRefOrGetter<FleetFidClaimUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetFidClaimUpdateInput = toValue(fleetFidClaimUpdateInput);

      return axiosClient<AdminFleetFidClaim>(
      {url: `/fleet-fid-claims/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fleetFidClaimUpdateInput, signal
    },
      );
    }




export const getUpdateFleetFidClaimMutationKey = () => ['updateFleetFidClaim'] as const;

export const getUpdateFleetFidClaimMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetFidClaim>>, TError,UpdateFleetFidClaimMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetFidClaim>>, TError,UpdateFleetFidClaimMutationVariables, TContext> => {

const mutationKey = getUpdateFleetFidClaimMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetFidClaim>>, UpdateFleetFidClaimMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateFleetFidClaim(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetFidClaimMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetFidClaim>>>
    export type UpdateFleetFidClaimMutationBody = FleetFidClaimUpdateInput
    export type UpdateFleetFidClaimMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateFleetFidClaimMutationVariables = {id: string;data: FleetFidClaimUpdateInput}

    /**
 * @summary Shorten an FID claim's grace period
 */
export const useUpdateFleetFidClaim = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetFidClaim>>, TError,UpdateFleetFidClaimMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetFidClaim>>,
        TError,
        UpdateFleetFidClaimMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetFidClaimMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel an FID claim
 */
export const cancelFleetFidClaim = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AdminFleetFidClaim>(
      {url: `/fleet-fid-claims/${id}/cancel`, method: 'PUT', signal
    },
      );
    }




export const getCancelFleetFidClaimMutationKey = () => ['cancelFleetFidClaim'] as const;

export const getCancelFleetFidClaimMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFleetFidClaim>>, TError,CancelFleetFidClaimMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelFleetFidClaim>>, TError,CancelFleetFidClaimMutationVariables, TContext> => {

const mutationKey = getCancelFleetFidClaimMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelFleetFidClaim>>, CancelFleetFidClaimMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  cancelFleetFidClaim(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelFleetFidClaimMutationResult = NonNullable<Awaited<ReturnType<typeof cancelFleetFidClaim>>>

    export type CancelFleetFidClaimMutationError = ErrorType<ValidationError | StandardError>
    export type CancelFleetFidClaimMutationVariables = {id: string}

    /**
 * @summary Cancel an FID claim
 */
export const useCancelFleetFidClaim = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFleetFidClaim>>, TError,CancelFleetFidClaimMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelFleetFidClaim>>,
        TError,
        CancelFleetFidClaimMutationVariables,
        TContext
      > => {
      return useMutation(getCancelFleetFidClaimMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Fleet
 */
export const createFleet = (
    fleetInput: MaybeRefOrGetter<FleetInput>,
 signal?: AbortSignal
) => {
      fleetInput = toValue(fleetInput);

      return axiosClient<Fleet>(
      {url: `/fleets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetInput, signal
    },
      );
    }




export const getCreateFleetMutationKey = () => ['createFleet'] as const;

export const getCreateFleetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,CreateFleetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,CreateFleetMutationVariables, TContext> => {

const mutationKey = getCreateFleetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleet>>, CreateFleetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createFleet(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetMutationResult = NonNullable<Awaited<ReturnType<typeof createFleet>>>
    export type CreateFleetMutationBody = FleetInput
    export type CreateFleetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateFleetMutationVariables = {data: FleetInput}

    /**
 * @summary Create Fleet
 */
export const useCreateFleet = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleet>>, TError,CreateFleetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleet>>,
        TError,
        CreateFleetMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleets list
 */
export const fleets = (
    params?: MaybeRefOrGetter<FleetsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Fleets>(
      {url: `/fleets`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetsQueryKey = (params?: MaybeRefOrGetter<FleetsParams>,) => {
    return [
    'fleets', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetsQueryOptions = <TData = Awaited<ReturnType<typeof fleets>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<FleetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleets>>> = ({ signal }) => fleets(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleets>>, TError, TData>
}

export type FleetsQueryResult = NonNullable<Awaited<ReturnType<typeof fleets>>>
export type FleetsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleets list
 */

export function useFleets<TData = Awaited<ReturnType<typeof fleets>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<FleetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Fleet Options
 */
export const fleetOptions = (
    params?: MaybeRefOrGetter<FleetOptionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FleetOptions>(
      {url: `/fleets/options`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetOptionsQueryKey = (params?: MaybeRefOrGetter<FleetOptionsParams>,) => {
    return [
    'fleets','options', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetOptionsQueryOptions = <TData = Awaited<ReturnType<typeof fleetOptions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<FleetOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetOptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetOptions>>> = ({ signal }) => fleetOptions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetOptions>>, TError, TData>
}

export type FleetOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetOptions>>>
export type FleetOptionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Options
 */

export function useFleetOptions<TData = Awaited<ReturnType<typeof fleetOptions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<FleetOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetOptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Fleet
 */
export const destroyFleet = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Fleet>(
      {url: `/fleets/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetMutationKey = () => ['destroyFleet'] as const;

export const getDestroyFleetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleet>>, TError,DestroyFleetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleet>>, TError,DestroyFleetMutationVariables, TContext> => {

const mutationKey = getDestroyFleetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleet>>, DestroyFleetMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyFleet(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleet>>>

    export type DestroyFleetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetMutationVariables = {id: string}

    /**
 * @summary Destroy Fleet
 */
export const useDestroyFleet = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleet>>, TError,DestroyFleetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleet>>,
        TError,
        DestroyFleetMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Detail
 */
export const fleet = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Fleet>(
      {url: `/fleets/${id}`, method: 'GET', signal
    },
      );
    }




export const getFleetQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',id
    ] as const;
    }


export const getFleetQueryOptions = <TData = Awaited<ReturnType<typeof fleet>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleet>>> = ({ signal }) => fleet(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleet>>, TError, TData>
}

export type FleetQueryResult = NonNullable<Awaited<ReturnType<typeof fleet>>>
export type FleetQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Detail
 */

export function useFleet<TData = Awaited<ReturnType<typeof fleet>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet
 */
export const updateFleet = (
    id: MaybeRefOrGetter<string>,
    fleetInput: MaybeRefOrGetter<FleetInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetInput = toValue(fleetInput);

      return axiosClient<Fleet>(
      {url: `/fleets/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetInput, signal
    },
      );
    }




export const getUpdateFleetMutationKey = () => ['updateFleet'] as const;

export const getUpdateFleetMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,UpdateFleetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,UpdateFleetMutationVariables, TContext> => {

const mutationKey = getUpdateFleetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleet>>, UpdateFleetMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateFleet(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleet>>>
    export type UpdateFleetMutationBody = FleetInput
    export type UpdateFleetMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateFleetMutationVariables = {id: string;data: FleetInput}

    /**
 * @summary Update Fleet
 */
export const useUpdateFleet = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleet>>, TError,UpdateFleetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleet>>,
        TError,
        UpdateFleetMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetMutationOptions(options), queryClient);
    }
    /**
 * @summary Verify a fleet's RSI org without the token check
 */
export const confirmFleetRsiVerification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Fleet>(
      {url: `/fleets/${id}/rsi-verification`, method: 'POST', signal
    },
      );
    }




export const getConfirmFleetRsiVerificationMutationKey = () => ['confirmFleetRsiVerification'] as const;

export const getConfirmFleetRsiVerificationMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmFleetRsiVerification>>, TError,ConfirmFleetRsiVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmFleetRsiVerification>>, TError,ConfirmFleetRsiVerificationMutationVariables, TContext> => {

const mutationKey = getConfirmFleetRsiVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmFleetRsiVerification>>, ConfirmFleetRsiVerificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  confirmFleetRsiVerification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmFleetRsiVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof confirmFleetRsiVerification>>>

    export type ConfirmFleetRsiVerificationMutationError = ErrorType<ValidationError | StandardError>
    export type ConfirmFleetRsiVerificationMutationVariables = {id: string}

    /**
 * @summary Verify a fleet's RSI org without the token check
 */
export const useConfirmFleetRsiVerification = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmFleetRsiVerification>>, TError,ConfirmFleetRsiVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof confirmFleetRsiVerification>>,
        TError,
        ConfirmFleetRsiVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmFleetRsiVerificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Revoke a fleet's RSI verification
 */
export const revokeFleetRsiVerification = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Fleet>(
      {url: `/fleets/${id}/rsi-verification`, method: 'DELETE', signal
    },
      );
    }




export const getRevokeFleetRsiVerificationMutationKey = () => ['revokeFleetRsiVerification'] as const;

export const getRevokeFleetRsiVerificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeFleetRsiVerification>>, TError,RevokeFleetRsiVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeFleetRsiVerification>>, TError,RevokeFleetRsiVerificationMutationVariables, TContext> => {

const mutationKey = getRevokeFleetRsiVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeFleetRsiVerification>>, RevokeFleetRsiVerificationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  revokeFleetRsiVerification(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeFleetRsiVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof revokeFleetRsiVerification>>>

    export type RevokeFleetRsiVerificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type RevokeFleetRsiVerificationMutationVariables = {id: string}

    /**
 * @summary Revoke a fleet's RSI verification
 */
export const useRevokeFleetRsiVerification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeFleetRsiVerification>>, TError,RevokeFleetRsiVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof revokeFleetRsiVerification>>,
        TError,
        RevokeFleetRsiVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeFleetRsiVerificationMutationOptions(options), queryClient);
    }
